import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

/** Calendar entry of a season that is not a race day — a qualification session
 *  ("Shootout") or a published season event. Both come from `seasonCalendar.php`
 *  already normalized to the same shape. */
export interface SeasonCalendarEntry {
    entry_type: 'qualification' | 'event';
    entry_id: number;
    season_id: number;
    title?: string | null;
    entry_date?: string | null;      // "YYYY-MM-DD"
    status?: string | null;
    note?: string | null;
    circuit_id?: number | null;
    circuit_name?: string | null;
    circuit_icon_small?: string | null;
    circuit_country?: string | null;
    streamer_name?: string | null;
    streamer_url?: string | null;
}

@Injectable()
export class SeasonCalendarService {
    private apiUrl = `${environment.apiBaseUrl}/api/seasonCalendar.php`;

    constructor(private http: HttpClient) {}

    /** Without a season all seasons are returned, so consumers can fetch once
     *  and filter client-side like they do with the race days. */
    getEntries(season_id?: number | null): Observable<SeasonCalendarEntry[]> {
        const query = season_id ? `?season_id=${season_id}` : '';
        return this.http.get<SeasonCalendarEntry[]>(`${this.apiUrl}${query}`).pipe(
            // These entries only enrich the race calendar — if the endpoint is
            // missing (not deployed yet) or fails, the calendar still renders.
            catchError(() => of([] as SeasonCalendarEntry[]))
        );
    }
}
